module.exports = "/images/brajan.jpg?ef817829923475b27ea75eacad116e72";